import Constants from '../constants.js'

export default {
   USER_URL:     Constants.BASE_URL + '/user',
   REGISTER_URL: Constants.BASE_URL + '/user/register'
}

export const Actions = {
   update: 'user:update',
   change: 'user:change'
}



// WEBPACK FOOTER //
// lib/api/user/Constants.js